import { Row } from "antd"
import classnames from "classnames"
import { FC } from "react"
import "./DividerWithHex.less"

type Props = {
  marginTop?: number
  marginBottom?: number
  color?: "primary" | "white" | "blue-gray"
}

const DividerWithHex: FC<Props> = ({ marginBottom, marginTop, color = "primary" }) => {
  const dividerStyles = classnames({
    "divider-with-hex": true,
    "white": color === "white",
    "blue-gray": color === "blue-gray",
  })

  return (
    <Row justify={"center"} className={dividerStyles} style={{ marginTop: marginTop, marginBottom: marginBottom }}>
      <div className={classnames("hex-small", color)} />
    </Row>
  )
}

export default DividerWithHex
